import {IToJson} from '@toolify/client/src/types/IToJson'

import {
  IFileVariantResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IFileVariantResponseInstance'

export function mapFileVariantResponseInstance(
  fileVariant: IToJson<IFileVariantResponseInstance>,
): IFileVariantResponseInstance {
  return {
    ...fileVariant,
  }
}
